/* Consent-aware anonymous identity. No provider, cart, customer or order transport. */
(function (window) {
  'use strict';
  if (window.hbAnalyticsIdentity) return;
  var KEY = 'hb.analytics.identity.v1';
  var TTL = 180 * 86400000;
  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
  var allowed = false, epoch = 0, record = null, listeners = [], mustRotate = false;

  function storage(action, value) {
    try {
      if (action === 'get') return window.localStorage.getItem(KEY);
      if (action === 'set') window.localStorage.setItem(KEY, value);
      if (action === 'remove') window.localStorage.removeItem(KEY);
    } catch (_) { /* Blocked storage must never block shopping. */ }
    return null;
  }
  function valid(value) {
    return value && value.schema === 1 && typeof value.visitor_id === 'string' &&
      UUID.test(value.visitor_id) && typeof value.created_at === 'number' &&
      isFinite(value.created_at) && value.created_at <= Date.now() &&
      value.created_at >= 0 && Date.now() - value.created_at < TTL;
  }
  function read() {
    try {
      var value = JSON.parse(storage('get'));
      return valid(value) ? value : null;
    } catch (_) { return null; }
  }
  function mint() {
    var id;
    try { id = window.crypto.randomUUID(); } catch (_) { return null; }
    if (typeof id !== 'string' || !UUID.test(id)) return null;
    var value = {schema: 1, visitor_id: id, created_at: Date.now()};
    storage('set', JSON.stringify(value));
    return value;
  }
  function snapshot() {
    if (!allowed || !valid(record)) return null;
    return {schema: 1, visitor_id: record.visitor_id, consent_epoch: epoch};
  }
  function notify() {
    listeners.slice().forEach(function (callback) {
      try { callback(snapshot()); } catch (_) { /* Isolate consumer failures. */ }
    });
    var current = snapshot();
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event: current ? 'hb_identity_ready' : 'hb_identity_cleared', hbIdentity: current});
    } catch (_) { /* A blocked dataLayer is not a checkout failure. */ }
  }
  function onConsent(state) {
    if (!state) return;
    var granted = state.analytics_storage === 'granted';
    if (!granted) {
      // The initial Consent Mode default is not the visitor's saved decision.
      var pendingDefault = state.wait_for_update != null && !allowed;
      if (!pendingDefault) { mustRotate = true; storage('remove'); }
      if (allowed || record) {
        allowed = false; record = null; epoch += 1; notify();
      }
      return;
    }
    if (allowed && valid(record)) return;
    allowed = true; epoch += 1; record = (!mustRotate && read()) || mint(); notify();
  }
  window.hbAnalyticsIdentity = {
    getSnapshot: snapshot,
    subscribe: function (callback) {
      if (typeof callback !== 'function') return function () {};
      listeners.push(callback);
      try { callback(snapshot()); } catch (_) { /* Isolate consumer failures. */ }
      return function () { listeners = listeners.filter(function (fn) { return fn !== callback; }); };
    },
    rotate: function () {
      mustRotate = true; storage('remove'); record = null; epoch += 1;
      if (allowed) record = mint();
      notify();
    }
  };
  if (typeof window.addEventListener === 'function') {
    // Shopify's standard storefront logout link is an explicit boundary between
    // shoppers. Hosted customer-account pages have their own origin and cannot
    // be observed here; no cross-device/customer identity is enabled.
    window.addEventListener('click', function (event) {
      try {
        var link = event.target && event.target.closest('a[href]');
        if (!link) return;
        var url = new URL(link.href, window.location.href);
        if (url.origin === window.location.origin && /\/account\/logout\/?$/.test(url.pathname)) {
          window.hbAnalyticsIdentity.rotate();
        }
      } catch (_) { /* Never interfere with navigation. */ }
    }, true);
    window.addEventListener('storage', function (event) {
      if (!event || (event.key !== KEY && event.key !== null) || !record) return;
      // Another tab may have revoked consent or logged out. Never keep sending
      // the old shopper's identity; wait for a fresh consent synchronization.
      mustRotate = true; allowed = false; record = null; epoch += 1; notify();
    });
  }
  if (window.hbConsentMode && typeof window.hbConsentMode.addListener === 'function') {
    window.hbConsentMode.addListener(onConsent);
  }
})(window);
